import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { getText } from '@educaplay/app-core/language';

export const BlockAcceptConditions = () => {

    const { mainReducer, appReducer } = useContext(MainContext);

    const handleOpenLicense = () => {
        appReducer.dispatch({
            type: 'openModal',
            payload: {
                id: 'license',
            },
        });
    };

    const handleOnChangeLegal = ({ target }) => {
        mainReducer.dispatch({
            type: 'setAcceptedConditions',
            payload: target.checked,
        });
    };

    return <div className="e__form">
        <input type="checkbox" id="legalCheck" checked={mainReducer.state.acceptedConditions} onChange={handleOnChangeLegal} />
        <label htmlFor="legalCheck">
            {getText('licencias_y_condiciones_disclaimer_2')}{' '}
        </label>
        <button onClick={handleOpenLicense} className="e__lnk">
            {getText('licencias_y_condiciones')}
        </button>
    </div>;
}
